import React from 'react';
import { Link } from 'react-router-dom';
import { LegalLayout, OPERATOR } from './LegalLayout';

export default function LegalCookies() {
    return (
        <LegalLayout title="Politica Cookies" lastUpdated="1 iunie 2026">
            <p>
                <strong>{OPERATOR.platform}</strong> folosește un număr minim de cookies — cele strict
                necesare pentru funcționarea serviciului (autentificare) și cookies de analytics anonimizate
                (Google Analytics 4) pentru a măsura traficul. Nu folosim cookies de marketing sau
                publicitate, nu profilăm utilizatorii și nu vindem date.
            </p>

            <h2>1. Ce sunt cookies?</h2>
            <p>
                Cookies sunt fișiere mici de text salvate de browser-ul tău (Chrome, Safari, Firefox etc.)
                pentru a-ți reține preferințele sau pentru a păstra sesiunea autentificată.
            </p>

            <h2>2. Ce cookies folosim</h2>
            <table style={{ width: '100%', borderCollapse: 'collapse', margin: '1rem 0', fontSize: '0.9rem' }}>
                <thead>
                    <tr style={{ background: 'var(--surface-2)' }}>
                        <th style={{ padding: 8, textAlign: 'left' }}>Nume</th>
                        <th style={{ padding: 8, textAlign: 'left' }}>Scop</th>
                        <th style={{ padding: 8, textAlign: 'left' }}>Durată</th>
                        <th style={{ padding: 8, textAlign: 'left' }}>Categorie</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style={{ padding: 8 }}><code>access_token</code></td>
                        <td style={{ padding: 8 }}>Autentificare sesiune (HTTP-only, nu poate fi citit din JS)</td>
                        <td style={{ padding: 8 }}>12 ore</td>
                        <td style={{ padding: 8 }}>Strict necesar</td>
                    </tr>
                    <tr>
                        <td style={{ padding: 8 }}><code>refresh_token</code></td>
                        <td style={{ padding: 8 }}>Reînnoire automată sesiune (HTTP-only)</td>
                        <td style={{ padding: 8 }}>7 zile</td>
                        <td style={{ padding: 8 }}>Strict necesar</td>
                    </tr>
                    <tr>
                        <td style={{ padding: 8 }}><code>_ga</code></td>
                        <td style={{ padding: 8 }}>Google Analytics — distinge vizitatori unici (IP anonimizat)</td>
                        <td style={{ padding: 8 }}>2 ani</td>
                        <td style={{ padding: 8 }}>Analytics</td>
                    </tr>
                    <tr>
                        <td style={{ padding: 8 }}><code>_ga_WPWK23NCV0</code></td>
                        <td style={{ padding: 8 }}>Google Analytics — stare sesiune curentă</td>
                        <td style={{ padding: 8 }}>2 ani</td>
                        <td style={{ padding: 8 }}>Analytics</td>
                    </tr>
                </tbody>
            </table>

            <h2>3. localStorage (similar cu cookies)</h2>
            <p>Salvăm și câteva preferințe local pe browser:</p>
            <table style={{ width: '100%', borderCollapse: 'collapse', margin: '1rem 0', fontSize: '0.9rem' }}>
                <thead>
                    <tr style={{ background: 'var(--surface-2)' }}>
                        <th style={{ padding: 8, textAlign: 'left' }}>Cheie</th>
                        <th style={{ padding: 8, textAlign: 'left' }}>Scop</th>
                        <th style={{ padding: 8, textAlign: 'left' }}>Categorie</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style={{ padding: 8 }}><code>access_token</code></td>
                        <td style={{ padding: 8 }}>Autentificare client-side (fallback)</td>
                        <td style={{ padding: 8 }}>Strict necesar</td>
                    </tr>
                    <tr>
                        <td style={{ padding: 8 }}><code>menu_lang</code></td>
                        <td style={{ padding: 8 }}>Limba preferată a meniului (RO, EN etc.)</td>
                        <td style={{ padding: 8 }}>Preferință utilizator</td>
                    </tr>
                </tbody>
            </table>

            <h2>4. Ce NU folosim</h2>
            <ul>
                <li>❌ Hotjar, Mixpanel, Amplitude sau alte unelte de session-recording</li>
                <li>❌ Facebook Pixel, Google Ads, LinkedIn Insights — niciun pixel de marketing</li>
                <li>❌ Cookies third-party de publicitate</li>
                <li>❌ Tracking cross-site sau profilare utilizatori</li>
            </ul>

            <h2>5. Google Analytics 4</h2>
            <p>
                Folosim Google Analytics 4 (Google Ireland Ltd.) pentru a măsura traficul agregat al
                site-ului (număr vizite, pagini populare, sursă — Google/direct/social, dispozitive).
                IP-ul vizitatorilor este anonimizat automat de GA4. Datele sunt agregate și nu permit
                identificarea ta personală.
            </p>
            <p>
                Nu folosim GA4 împreună cu Google Ads sau alte unelte de publicitate — doar pentru
                statistici de produs. Poți dezactiva GA4 cu orice extensie anti-tracking (uBlock, Privacy
                Badger) sau din setările "Do Not Track" ale browser-ului.
            </p>

            <h2>6. Consimțământ</h2>
            <p>
                Cookies strict necesare <strong>nu necesită consimțământ explicit</strong> conform
                Directivei ePrivacy + GDPR (art. 5(3) ePrivacy) — sunt indispensabile pentru funcționarea
                serviciului pe care l-ai solicitat (login, sesiune).
            </p>
            <p>
                Pentru GA4 (analytics), folosim configurația minimă cu IP anonimizat și fără semnal de
                publicitate, considerată sub pragul care necesită consimțământ explicit pentru statistici
                agregate de trafic. Dacă vom adăuga pe viitor cookies de marketing, vom afișa banner de
                consimțământ.
            </p>

            <h2>7. Cum dezactivezi cookies</h2>
            <p>
                Poți dezactiva cookies din setările browser-ului. <strong>Atenție:</strong> dacă dezactivezi
                cookies strict necesare, autentificarea NU va funcționa și nu vei putea folosi Platforma.
            </p>
            <ul>
                <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Chrome</a></li>
                <li><a href="https://support.mozilla.org/ro/kb/cookies" target="_blank" rel="noopener noreferrer">Firefox</a></li>
                <li><a href="https://support.apple.com/ro-ro/guide/safari/sfri11471" target="_blank" rel="noopener noreferrer">Safari</a></li>
                <li><a href="https://support.microsoft.com/ro-ro/microsoft-edge" target="_blank" rel="noopener noreferrer">Edge</a></li>
            </ul>

            <h2>8. Mai multe detalii</h2>
            <p>
                Vezi <Link to="/legal/privacy" style={{ color: 'var(--amber)' }}>Politica de Confidențialitate</Link>{' '}
                pentru cum tratăm datele personale în general.
            </p>

            <h2>9. Contact</h2>
            <p>
                Pentru întrebări despre cookies: <a href={`mailto:${OPERATOR.email}`}>{OPERATOR.email}</a>
            </p>
        </LegalLayout>
    );
}
